import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputElementProps, InputProps, MonetaryInput } from '../../UI';
import { BusinessFormValues } from '../types';
import { FC } from 'react';

type BusinessEstimatedValueInputProps = Pick<InputProps, 'className'> &
  Pick<InputElementProps, 'autoFocus'> & { helperText?: string };

export const BusinessEstimatedValueInput: FC<BusinessEstimatedValueInputProps> = ({
  className,
  autoFocus,
  helperText,
}) => {
  const { t: tForm } = useTranslation('form');
  const { control } = useFormContext<BusinessFormValues>();
  const {
    field,
    formState: { errors },
  } = useController<BusinessFormValues, 'estimatedValue'>({
    control,
    name: 'estimatedValue',
    rules: { required: true },
  });

  return (
    <MonetaryInput
      helperText={helperText}
      {...field}
      autoFocus={autoFocus}
      className={className}
      status={errors.estimatedValue ? 'errored' : 'normal'}
      label={tForm('business-estimated-value-input-label')}
      inputProps={{ placeholder: tForm('general-placeholder-required') }}
    />
  );
};
